export default __webpack_public_path__ + "static/media/admin.28e908d8.jpg";